/* ERP Robust Group — personalizacion del login (solo #page-login):
   - cabecera: fila de 4 logos iguales [Coco · Robust · Bull · Fox] + titulos
   - iconos inline de correo/candado (garantizados, sin depender del sprite)
   - "Show" -> ojo que muestra/oculta la contrasena
   Inyectado via web_include_js. */
(function () {
  var EYE = '<svg viewBox="0 0 16 16" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M1 8s2.6-4.6 7-4.6 7 4.6 7 4.6-2.6 4.6-7 4.6S1 8 1 8z"/><circle cx="8" cy="8" r="2"/></svg>';
  var EYE_OFF = '<svg viewBox="0 0 16 16" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M6.4 3.6A6.9 6.9 0 0 1 8 3.4c4.4 0 7 4.6 7 4.6a13.2 13.2 0 0 1-2.1 2.7M3.8 4.9A12.7 12.7 0 0 0 1 8s2.6 4.6 7 4.6a6.8 6.8 0 0 0 2.7-.5"/><path d="M1.7 1.7l12.6 12.6"/></svg>';
  var MAIL = '<g fill="none" stroke="#9a9a9a" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="1.7" y="3.3" width="12.6" height="9.4" rx="2"/><path d="M2.2 4.2 8 8.6l5.8-4.4"/></g>';
  var LOCK = '<g fill="none" stroke="#9a9a9a" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="3.4" y="7" width="9.2" height="6.6" rx="1.6"/><path d="M5.5 7V5.1a2.5 2.5 0 0 1 5 0V7"/></g>';

  function brandHead() {
    document.querySelectorAll("#page-login .page-card-head").forEach(function (head) {
      if (head.dataset.erpBranded) return;
      head.dataset.erpBranded = "1";
      head.innerHTML =
        '<div class="erp-login-head">' +
        '  <div class="erp-logos">' +
        '    <img class="erp-logo" src="/assets/erp_robust_group/images/coco-isotipo.webp" alt="Coco Car Wash">' +
        '    <img class="erp-logo" src="/assets/erp_robust_group/images/robust-isotipo.png" alt="Robust">' +
        '    <img class="erp-logo" src="/assets/erp_robust_group/images/bull-isotipo.svg" alt="Bull Tires">' +
        '    <img class="erp-logo" src="/assets/erp_robust_group/images/fox-logo.png" alt="Fox Tires">' +
        '  </div>' +
        '  <div class="erp-titles">' +
        '    <div class="erp-t1">Iniciar sesión</div>' +
        '    <div class="erp-t2">ERP Robust Group</div>' +
        '  </div>' +
        "</div>";
    });
  }

  function enhanceInputs() {
    var root = document.querySelector("#page-login");
    if (!root) return;
    var em = root.querySelector(".email-icon");
    if (em) em.innerHTML = MAIL;
    var lk = root.querySelector(".password-icon");
    if (lk) lk.innerHTML = LOCK;

    var pw = root.querySelector("#login_password");
    var pf = pw && pw.closest(".password-field");
    if (pf && !pf.querySelector(".erp-eye")) {
      var old = root.querySelector(".toggle-password");
      if (old) old.style.display = "none";
      var eye = document.createElement("button");
      eye.type = "button";
      eye.className = "erp-eye";
      eye.setAttribute("aria-label", "Mostrar u ocultar contraseña");
      eye.innerHTML = EYE;
      eye.addEventListener("click", function () {
        var show = pw.type === "password";
        pw.type = show ? "text" : "password";
        eye.innerHTML = show ? EYE_OFF : EYE;
        pw.focus();
      });
      pf.appendChild(eye);
    }
  }

  function run() {
    brandHead();
    enhanceInputs();
  }

  // Splash del GRUPO al cargar el login (misma animación que el desk). Cubre el arranque
  // para que no se vea el "deformado" mientras la página se estiliza.
  function showGroupSplash() {
    if (document.querySelector(".erp-splash")) return;
    var A = "/assets/erp_robust_group/images/";
    var ov = document.createElement("div");
    ov.className = "erp-splash";
    ov.setAttribute("data-brand", "grupo");
    ov.innerHTML =
      '<div class="erp-splash-fx"></div>'
      + '<div class="erp-splash-inner erp-splash-grupo"><div class="erp-splash-logos">'
      + '<span class="erp-splash-chip erp-g-coco"><img src="' + A + 'coco-isotipo.webp" alt=""></span>'
      + '<span class="erp-splash-chip erp-g-robust"><img src="' + A + 'robust-isotipo.png" alt=""></span>'
      + '<span class="erp-splash-chip erp-g-bull"><img src="' + A + 'bull-isotipo.svg" alt=""></span>'
      + '<span class="erp-splash-chip erp-g-fox"><img src="' + A + 'fox-logo.png" alt=""></span>'
      + "</div></div>";
    (document.body || document.documentElement).appendChild(ov);
    setTimeout(function () {
      ov.classList.add("out");
      // el formulario aparece SUAVEMENTE detrás mientras el splash se desvanece
      var pg = document.getElementById("page-login");
      if (pg) pg.classList.add("erp-ready");
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 650);
    }, 2000);
  }

  showGroupSplash();
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
})();
